(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.GalleryOnPage = global.NewHomeSource.GalleryOnPage || {};
  global.NewHomeSource.GalleryOnPage.CommunityTracking = global.NewHomeSource.GalleryOnPage.CommunityTracking || {};

  class Ga4Events {
    /**
     * Initializes a new instance of the class.
     * Sets the rootNode property to null.
     */
    constructor() {
      this.rootNode = null;
    }

    /**
     * Sets the root node for the instance.
     *
     * @param {HTMLElement} rootNode - The root DOM node to be assigned.
     * @returns {this} Returns the current instance for chaining.
     */
    setRootNode(rootNode) {
      this.rootNode = rootNode;
      return this;
    }

    static carouselNavigationGa4Event(detail) {
      const originator = detail.originator;
      const params = {};
      switch (originator) {
        case 'nextArrow':
          params.click_target = 'arrow_clicked';
          params.click_target1 = 'forward_clicked';
          break;
        case 'previousArrow':
          params.click_target = 'arrow_clicked';
          params.click_target1 = 'backward_clicked';
          break;
        case 'dragNavigation':
          params.click_target = 'image_swap';
          break;
        default:
          params.click_target = '';
      }
      const eventGa4 = {
        eventName: 'gallery_detail_pages',
        params,
        eventType: 'GA4Event',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventGa4 }
      }));
    }
  }

  global.NewHomeSource.GalleryOnPage.CommunityTracking.Ga4Events = Ga4Events;
}(window));
